/** Der Schriftzug aus dem Logo: VLZ in Navy, HU in Türkis, B in Orange. */
export function Wortmarke() {
  return (
    <div className="wortmarke">
      <span className="vlz">VLZ</span>
      <span className="hu">HU</span>
      <span className="b">B</span>
    </div>
  )
}
